import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth/authSlice';
import licenseReducer from './license/licenseSlice';
import fieldFillingControllReducer from './schemaSlice/fieldFillingControllSlice'; 

export const store = configureStore({
  reducer: {
    auth: authReducer,
    fieldFillingControll: fieldFillingControllReducer,
    license: licenseReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
